export function loadAmbassadorWixEventsWebHttp() {
	return import('@wix/ambassador-wix-events-web/http' /* webpackChunkName: "wixEventsWeb" */)
}
